<template>
    <div class="registrationWrapper">
        <div class="container">
            <div class="whiteBG-wrap">
                <div class="row">                
                    <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-7">
                        <div class="regForm-wrap">
                            <h2>Payment Information</h2>
                            <hr>
                            <payment-form />
                        </div>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-5">
                        <payment-side-info />
                    </div>                    
                </div>
                <span class="procecss-title">Employer Registration</span>
            </div>
        </div>        
    </div>
</template>
<script>
import PaymentForm from '../../components/Registration/PaymentInfo/PaymentForm.vue'
import PaymentSideInfo from '../../components/Registration/PaymentInfo/PaymentSideInfo.vue'
export default {
    name: 'PaymentInfo',
    components: {
        PaymentForm,
        PaymentSideInfo
    }
}
</script>
<style src="../../assets/css/group-registration.css"></style>